// extracted by mini-css-extract-plugin
module.exports = {"user":"ImpersonatedUserView_user__GkiGg","name":"ImpersonatedUserView_name__qk_kg","company":"ImpersonatedUserView_company__tbE_1"};